import moment from "moment";
export class StaffJobHistory {
  StaffID;
  DateJoin;
  DateResign;
  EmpType;
  Company;
  PostJoin;
  PostLeft;
  LeaveReason;
  RefChk;
  RefLetter;
  AddBy;
  ModifyBy;
  Seq;
  tempCode;
  IsEditMode;
  EmployTypeDes;
  JobHistoryURL;
  JobHistoryFile;
  DocMime;
  IsImageFile;
  IsJoinMenuActive;
  IsResignMenuActive;
  constructor() {
    this.StaffID = "";
    this.DateJoin = moment().format("YYYY-MM-DD");;
    this.DateResign = moment().format("YYYY-MM-DD");;
    this.EmpType = "";
    this.Company = "";
    this.PostJoin = "";
    this.PostLeft = "";
    this.LeaveReason = "";
    this.RefChk = false;
    this.RefLetter = "";
    this.AddBy = "";
    this.ModifyBy = "";
    this.IsEditMode = false;
    this.Seq = "";
    this.tempCode =  "";
    this.EmployTypeDes = "";
    this.JobHistoryURL = "";
    this.JobHistoryFile = "";
    this.DocMime = "";
    this.IsImageFile = false;
    this.IsJoinMenuActive = false;
    this.IsResignMenuActive = false;
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffJobHistory.js